(function(window, document, cutme, undefined) {

	const Helper = function() {
        return {
            detach: detach,
            detachAfter: detachAfter,
        	setRowHeights: setRowHeights
        };
    };

    const detach = function(node, target) {
        let parent = node.parentNode,
            next = node.nextSibling;

        if (!parent) { return; }
        
        parent.removeChild(node);
        target.appendChild(node, next);
    }

    const detachAfter = function(node, target) {
        var parent = node.parentNode;
        var next = node.nextSibling;
        if (!parent) { return; }
        
        function insertAfter(newNode, referenceNode) {
            referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
        }
        
        parent.removeChild(node);
        insertAfter(node, target);
    }
    
    const setRowHeights = function() { 
        
        function setRowBySection(selector) {  
    
            let itemContentSections = document.querySelectorAll(selector);

            // remove any previously set heights
            itemContentSections.forEach(function(item){
                item.style.height = "";
            });


            // set the maximum content section height for each row
            let rows = [[]],
                rowMaxHeight = [0],
                currentRowIndex = 0,
                currentRowOffset,
                numberOfItems = itemContentSections.length;


          itemContentSections.forEach(function(item, index){
            var height = item.offsetHeight;
            var offset = item.getBoundingClientRect().top;    
            if (currentRowOffset && currentRowOffset !== offset){
              // this item is on the next row
              // so increase the rowIndex and set the defaults
              currentRowIndex += 1;
              rows[currentRowIndex]=[];
              rowMaxHeight[currentRowIndex]=0;
            } 
            // add this item to the relevant row
            rows[currentRowIndex].push(item);
            // check for max section height on this row
            rowMaxHeight[currentRowIndex] = (height > rowMaxHeight[currentRowIndex]) ? height : rowMaxHeight[currentRowIndex];   
            currentRowOffset = offset;
          });
          applyRowHeights(rows, rowMaxHeight);
        }
        
        // apply a fixed height to an array of DOM elements
        function applyRowHeights(rows, rowMaxHeight){
          rows.forEach(function(row, index){
            var maxHeight = rowMaxHeight[index];
            row.forEach(function(item){
              // set height minus 20px to account for padding
              item.style.height = (maxHeight) + "px";
            });
          });
        }

        setRowBySection('.js-postsTitle');
        setRowBySection('.js-postsExcerpt');
    }

    
    cutme.helper = new Helper();



}(window, document, window.cutme = window.cutme  || {}));
